import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const isImportError =
        this.state.error &&
        typeof this.state.error.message === 'string' &&
        /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(this.state.error.message);

      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
          <div className="max-w-md w-full text-center p-8 border border-border rounded-lg bg-card">
            <h1 className="font-heading text-2xl mb-3 text-foreground">
              {isImportError ? 'Oppdatering tilgjengelig' : 'Noe gikk galt'}
            </h1>
            <p className="text-sm text-muted-foreground mb-6">
              {isImportError
                ? 'En ny versjon av siden er tilgjengelig. Last inn på nytt for å fortsette.'
                : (this.state.error?.message || 'Det oppstod en uventet feil.')}
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-3 bg-primary text-primary-foreground rounded font-medium hover:opacity-90 transition-opacity"
            >
              Last inn på nytt
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}